export const createBalanceRoute = '/balance/create';
export const getBalancesRoute = '/balance/get';
export const updateBalanceRoute = '/balance/update';
export const deleteBalanceRoute = '/balance/delete';
